"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const straighteninghair = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-straighteninghair` : '') + (description ? ` desc-straighteninghair` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-straighteninghair"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-straighteninghair"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.85 1a8.85 8.85 0 0 1 8.85 8.85v11.7a.75.75 0 0 1-1.5 0V9.85c0-2.75-1.5-5.14-3.74-6.4.36.68.59 1.42.66 2.19a.75.75 0 1 1-1.5.14 4.26 4.26 0 0 0-2.01-3.24V7.2a.75.75 0 0 1-1.5 0V2.54l-.3.03a4.26 4.26 0 0 0-1.96 3.2.75.75 0 0 1-1.5-.13c.07-.7.26-1.37.57-2A7.34 7.34 0 0 0 4.5 9.85v11.78a.75.75 0 0 1-1.5 0V9.85A8.85 8.85 0 0 1 11.85 1Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.15 16c.41 0 .75.34.75.75v4.5a.75.75 0 0 1-1.5 0v-4.5c0-.41.34-.75.75-.75Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.95 16c.41 0 .75.34.75.75v4.5a.75.75 0 0 1-1.5 0v-4.5c0-.41.34-.75.75-.75Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.85 8.81c.46 0 1.05.28 1.15.93l.01.13v.19c0 1.01-.3 2.97-1.1 4.75a7.37 7.37 0 0 1-2.12 2.83 24.87 24.87 0 0 0 .34 2.58 1.87 1.87 0 0 0 .07.23.75.75 0 0 1-1.11 1 1.33 1.33 0 0 1-.28-.44 9.87 9.87 0 0 1-.32-1.4c-.06-.4-.1-.82-.14-1.21a4.72 4.72 0 0 1-2.9-.02c-.03.4-.07.84-.15 1.26-.06.36-.15.73-.28 1.05-.12.29-.33.7-.75.9a.75.75 0 0 1-.72-1.31 3.78 3.78 0 0 0 .28-.9c.1-.62.14-1.32.14-1.78a8.1 8.1 0 0 1-2.14-2.54c-.52-.92-.9-1.9-1.12-2.8a7.17 7.17 0 0 1-.27-2.37l.02-.14c.14-.64.74-.94 1.23-.94h10.16Zm-9.93 1.5c0 .4.08.94.24 1.58.2.78.53 1.64.98 2.44.91 1.63 2.2 2.79 3.77 2.79 1.7 0 2.87-1.24 3.63-2.93.66-1.44.92-3.02.97-3.88H6.92Z",
    fill: "#232323"
  }));
};
var _default = exports.default = straighteninghair;